<template>
  <div class="volumes">
    <i class="fa fa-chevron-right"
       @click="dialogObject = true"
    />
    <el-dialog
      append-to-body
      width="400px"
      :title="`Добавление перечня ${tra[type]}`" :visible.sync="dialogObject">
      <div class="volumes">

        <div class="jobs-ul" v-if="!isSelect">
          <el-button size="small" class="add" type="primary" style="width: 100%; margin-bottom: 10px"
                     @click="isSelect = !isSelect">
            + Выбрать {{ tr[type] }}
          </el-button>
          <div style="display: flex; justify-content: flex-start">
          </div>
          <div
            class="jobs-li pick flex space-between" v-for="(job, index) in result" :key="index"
          >
            <div>
              <div class="flex" style="justify-content: flex-start">
                <span>{{ job.name }}</span>
              </div>
            </div>

            <div class="flex align">
              <div>
                <el-input size="small" v-model.number="job.plan" style="width: 80px"/>
              </div>
              <i class="el-icon-close" style="margin-left: 10px" @click="remove(index)"/>
            </div>
          </div>

          <div style="display: flex; justify-content: center; margin-top: 12px">
            <strong>Итого: {{ total }}</strong>
          </div>
        </div>

        <div class="jobs-ul" v-else>
          <div
            class="jobs-li" v-for="(job, index) in list" :key="index" @click="add(job)"
          >
            <span>{{ job.name }}</span>
          </div>

          <el-button size="small" class="add" style="width: 100%; margin: 20px 0 0 0" @click="isSelect = !isSelect">
            Назад
          </el-button>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="close">Закрыть</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import firebase from "firebase";
import {getCurrentMonth} from "../../../../utils/date";

export default {
  name: "AddProfTech",
  props: {
    jobName: "",
    table: [Object, Array],
    type: String,
  },
  data() {
    return {
      dialogObject: false,
      isSelect: false,
      result: [],
      list: [],
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        this.result = [
          ...(table.table || [])
        ]
      }
    }
  },
  methods: {
    add(job) {
      this.result.push(job);
      this.isSelect = false;
    },
    open() {

    },
    save() {
      this.$emit('save', {
        table: [
          ...this.result,
        ],
        total: this.total,
        time: this.result.time || 0,
        fact: this.result.fact || 0
      })


      this.close()
    },

    close() {
      this.result = []

      this.dialogObject = false;
    },

    remove(index) {
      const result = [...this.result];
      result.splice(index, 1)
      this.result = [...result];
    }
  },
  mounted() {
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
          })
        })

        this.list = result;
      });
  },
  computed: {
    total() {
      let result = 0;

      this.result.forEach(({plan}) => {
        result += plan || 0
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">
.volumes {
  max-width: 95%;
  margin: 0 auto;
}

.create-footer {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: flex-start;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  text-align: left;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    padding-bottom: 8px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/components/AddProfTech.vue